import { normalizeResolvedPath } from '../../../paths/normalize-resolved-path.js';
import { withCodeNavCacheSqlite } from '../../../sqlite/code-nav-cache/database.js';
import { upsertSymbolIndexParentPath } from '../sqlite/symbol-index-sqlite.js';

/** Register parent row without indexing files (cheap). */
export async function registerSymbolIndexParentAsync(parentPath: string): Promise<void> {
  const resolved = normalizeResolvedPath(parentPath);
  await withCodeNavCacheSqlite((db) => {
    upsertSymbolIndexParentPath(db, resolved);
  });
}

/** @deprecated Prefer {@link registerSymbolIndexParentAsync}. */
export function registerSymbolIndexParent(parentPath: string): void {
  void registerSymbolIndexParentAsync(parentPath);
}
